import EnterpriseScene from './EnterpriseScene';

export default function PageHero({ label, title, tagline, lead, children, className = '' }) {
  return (
    <header className={`page-hero page-hero--enterprise${className ? ` ${className}` : ''}`}>
      <EnterpriseScene />
      <div className="container page-hero__content">
        {label && <p className="page-hero__label">{label}</p>}
        <h1>{title}</h1>
        {tagline && <p className="page-hero__tagline">{tagline}</p>}
        {lead && <p className="page-hero__lead">{lead}</p>}
        {children}
      </div>
    </header>
  );
}
